<h1 mat-dialog-title>Create File</h1>
<div mat-dialog-content class="create-dialog">
  <form class="create-form">
    <mat-form-field class="create-input" appearance="fill">
      <mat-label>File Name</mat-label>
      <input
        type="text"
        id="create-file"
        matInput
        [formControl]="fileCreateFormControl"
        placeholder="myFile.txt"
      />
    </mat-form-field>
    <mat-error *ngIf="fileCreateFormControl.hasError('required')">
      Filename is <strong>required</strong>
    </mat-error>
  </form>
</div>
<div mat-dialog-actions>
  <button id="close" mat-button (click)="close()">Cancel</button>
  <button id="create" mat-button (click)="createFile()">Create</button>
</div>
